import { updateWalletData } from "@/store/slices/walletSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAccount, useConnect, useConnectors } from "wagmi";

const useAutoConnect = () => {
  const connectors = useConnectors();
  const { connect } = useConnect();
  const { isConnected } = useAccount();
  const dispatch = useDispatch();

  useEffect(() => {

    const isLedgerLive = window?.ethereum?.isLedgerLive || /Ledger/i.test(navigator.userAgent);

    if (isConnected || !isLedgerLive) {
      dispatch(updateWalletData({
        isLoading: false,
      }));
      return;
    }

    // Use existing injected connector from config, not inline creation
    const injectedConnector = connectors.find((c: any) => c.id === "com.ledger");


    if (injectedConnector) {
      connect({ connector: injectedConnector });

      dispatch(updateWalletData({
        isLoading: false,
      }));
    }

  }, [connect, connectors, dispatch, isConnected]);
};

export default useAutoConnect;